import { formatShanghaiDateTime } from '../../utils/datetime';
import { formatPaymentAmount } from '../../utils/checkoutPricing';

export const TRIAL_PROMO_REASON_TEXT_MAP = {
  unused: '新人体验价可用（仅一次）',
  unknown: '新人体验价状态获取中',
};

export const QUOTA_TOOLTIP_MAP = {
  accounts: '账号数：可绑定并管理的社交媒体账号总数上限。',
  tasks: '任务数：可创建并保存的发布任务总数上限。',
  monthly: '月发布：每个自然月内可完成的发布次数上限，次月自动重置。',
  storage: '存储空间：内容库素材可占用的总容量上限（图片/视频/文案等）。',
};

export const toNonNegativeInt = (value) => {
  const n = Number(value || 0);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
};

export const formatStorage = (bytes) => {
  const n = toNonNegativeInt(bytes);
  if (n >= 1024 * 1024 * 1024) return `${(n / (1024 * 1024 * 1024)).toFixed(2).replace(/\.00$/, '')}GB`;
  if (n >= 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(2).replace(/\.00$/, '')}MB`;
  if (n >= 1024) return `${(n / 1024).toFixed(2).replace(/\.00$/, '')}KB`;
  return `${n}B`;
};

export const formatDateTime = (value) => formatShanghaiDateTime(value);

export const isPaymentApplied = (payment) => String(payment?.fulfillment_status || '').trim().toLowerCase() === 'applied';

export const formatCreditPackUnitPrice = (pack) => {
  const credits = toNonNegativeInt(pack?.credits);
  const amount = Number(pack?.price_cents || 0);
  if (credits <= 0 || amount <= 0) return '';
  const per100 = Math.round((amount / credits) * 100);
  return `约 ${formatPaymentAmount(per100, pack?.currency)}/100 积分`;
};

export const toUtcMs = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return 0;
  const dt = new Date(raw);
  const ms = dt.getTime();
  return Number.isFinite(ms) ? ms : 0;
};

export const planDurationDays = (plan) => {
  const d = Number(plan?.duration_days || 0);
  if (!Number.isFinite(d) || d <= 0) return Number.MAX_SAFE_INTEGER;
  return d;
};
